import { render, staticRenderFns } from "./ProjectSettingsNav.vue?vue&type=template&id=f230f418&scoped=true"
import script from "./ProjectSettingsNav.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsNav.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsNav.vue?vue&type=style&index=0&id=f230f418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f230f418",
  null
  
)

export default component.exports